import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getSplitSupplyContract,
  getSplitSupplyContractFormOptions,
  listSplitSupplyContracts,
  updateSplitSupplyContract,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 分割供給契約 更新 (楽観ロック: expectedUpdatedAt を request に含める) mutation hook。
 * 成功したら一覧・詳細・登録フォームの候補 (契約済みの地点が出入りする) を最新化する。
 */
export function useUpdateSplitSupplyContract(): InvalidatingMutationResultFor<
  typeof updateSplitSupplyContract
> {
  return useInvalidatingMutation(updateSplitSupplyContract, [
    createConnectQueryKey({
      schema: listSplitSupplyContracts,
      cardinality: 'finite',
    }),
    createConnectQueryKey({
      schema: getSplitSupplyContract,
      cardinality: 'finite',
    }),
    createConnectQueryKey({
      schema: getSplitSupplyContractFormOptions,
      cardinality: 'finite',
    }),
  ])
}
